import { useState } from "react";
import { Check, MoreHorizontal } from "lucide-react";

import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "../../lib/utils";

// Menu ⋯ da barra de ferramentas: o que a pessoa tirou da barra sem esconder
// (preferência `ferramentasNoMenu`). Sem nada dentro, o botão nem aparece.
//
// Popover e não DropdownMenu: "Visões salvas" tem campo de texto, e o menu do
// Radix toma as teclas para a busca por letra.
//
// `itens`: { id, rotulo, icone, aoClicar, ativo? } — com `ativo` é chave de
// liga/desliga e o menu fica aberto; sem, é ação e o menu fecha.
// `secoes`: { id, titulo, conteudo, ativo? } — o mesmo conteúdo do popover da barra.
const MenuDaLista = ({ itens, secoes }) => {
  const [aberto, setAberto] = useState(false);

  if (!itens.length && !secoes.length) return null;

  // Filtro ligado dentro do menu não pode valer em silêncio: o botão conta.
  const ativos = [...itens, ...secoes].filter((i) => i.ativo).length;

  return (
    <Popover open={aberto} onOpenChange={setAberto}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={
            ativos ? `Mais ferramentas (${ativos} ligada${ativos > 1 ? "s" : ""})` : "Mais ferramentas"
          }
          title="Mais ferramentas"
          className={cn(
            "relative flex h-8 w-8 items-center justify-center rounded-full transition-colors",
            aberto
              ? "bg-primary/10 text-primary"
              : "text-muted-foreground hover:bg-muted hover:text-foreground",
          )}
        >
          <MoreHorizontal className="h-[18px] w-[18px]" />
          {ativos > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[9px] font-bold tabular-nums text-primary-foreground">
              {ativos}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="scrollbar-discreta max-h-[70vh] w-64 overflow-y-auto p-1"
      >
        {itens.map(({ id, rotulo, icone: Icone, ativo, aoClicar }) => (
          <button
            key={id}
            type="button"
            aria-pressed={ativo}
            onClick={() => {
              aoClicar();
              if (ativo === undefined) setAberto(false);
            }}
            className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors hover:bg-accent"
          >
            <Icone className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="min-w-0 flex-1 truncate">{rotulo}</span>
            {ativo && <Check className="h-4 w-4 shrink-0 text-primary" />}
          </button>
        ))}

        {secoes.map((secao) => (
          <div
            key={secao.id}
            className="mt-1 border-t px-1 pt-1 first:mt-0 first:border-t-0 first:pt-0"
          >
            <p className="px-1 py-1 text-xs font-medium text-muted-foreground">
              {secao.titulo}
            </p>
            {secao.conteudo}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default MenuDaLista;
